export const WORK_INJURY_DESCRIPTION =
  "Ensure contractors have the required coverage for on-the-job injuries. Our AI verifies their Worker's Compensation or Occupational Accident policy, protecting both them and your business from liability.";
export const WORK_INJURY_EXAMPLE_USE_CASES =
  "Verify contractors have coverage for medical bills and lost income if they are injured on the job.";
export const WORK_INJURY_COST = "$15 per verification";

export const WORK_INJURY = {
  description: WORK_INJURY_DESCRIPTION,
  exampleUseCases: WORK_INJURY_EXAMPLE_USE_CASES,
  cost: WORK_INJURY_COST
};
